import { Link } from "react-router-dom";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import "./NotFound.css";

export default function NotFound() {
    return (
        <>
            <Header isHomePage={false} onGiftToggle={() => { }} isGiftMode={false} />
            <div className="not-found">
                <h1>404</h1>
                <p>Sorry, the page you're looking for doesn't exist.</p>
                <Link to="/" className="not-found__link">Go back home</Link>
            </div>
            <Footer />
        </>
    );
}
